/** Copyright 2023 Midas Healthcare Solutions - All Rights Reserved **/
import { CollectionBin, CollectionBox } from './collection-bin.model';

export interface Cart {
  id: number;
  guid: string;
  cartType: number;
  name: string | null;
  locationId: number;
  locationName: string;
  createdAt: string;
  updatedAt: string | null;
  collectionBins: CollectionBin[];
  collectionBox: CollectionBox;
  windowsMachineName: string;
}

export interface CartNotifications{
  id: number;
  guid: string;
  name: string | null;
  locationId: number;
  locationName: string;
  timeStamp: string;
  errorCode: number;
  notification: string;
}

export enum CartType{
  MedSurg = 0,
  Pro = 1,
  Mini = 2,
}